import React from 'react';
import { 
  UserIcon, 
  CogIcon, 
  ShieldCheckIcon,
  PhotoIcon
} from '@heroicons/react/24/outline';

interface ProfileSidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const ProfileSidebar: React.FC<ProfileSidebarProps> = ({ activeTab, onTabChange }) => {
  const menuItems = [
    {
      id: 'profile',
      label: '基本信息',
      icon: UserIcon,
      description: '管理个人资料和头像'
    },
    {
      id: 'security',
      label: '账户安全',
      icon: ShieldCheckIcon,
      description: '密码和登录设置'
    },
    {
      id: 'album',
      label: '团队活动相册',
      icon: PhotoIcon,
      description: '团队活动照片管理'
    },
    {
      id: 'settings',
      label: '系统设置',
      icon: CogIcon,
      description: '偏好设置和配置'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">个人中心</h3>
        <p className="text-sm text-gray-600">管理您的账户和设置</p>
      </div>
      
      <nav className="space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors ${
                isActive
                  ? 'bg-primary-50 text-primary-700 border border-primary-200'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <Icon className={`h-5 w-5 ${
                isActive ? 'text-primary-600' : 'text-gray-400'
              }`} />
              <div className="flex-1">
                <div className="font-medium">{item.label}</div>
                <div className="text-xs text-gray-500 mt-1">{item.description}</div>
              </div>
            </button>
          );
        })}
      </nav>
      
      <div className="mt-8 pt-6 border-t border-gray-200">
        <div className="text-xs text-gray-500 mb-3">账户状态</div>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
          <span className="text-sm text-gray-700">账户正常</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileSidebar;
